import React from 'react';
import PropTypes from 'prop-types';
import { FlexContainer } from "../../layout/FlexContainer";
import { Button } from "../../elements/Button";
import { ICON_NAMES } from "../../elements/Icon";
import { Paragraph } from "../../typography/Paragraph";
export var Component = function Component(_ref) {
  var max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      onChange = _ref.onChange,
      renderValue = _ref.renderValue,
      value = _ref.value;

  var handleDecrement = function handleDecrement() {
    value !== min && onChange(name, value - 1);
  };

  var handleIncrement = function handleIncrement() {
    value !== max && onChange(name, value + 1);
  };

  return React.createElement("div", {
    className: "ui counter"
  }, React.createElement(FlexContainer, {
    alignItems: "center",
    justifyContent: "space-between"
  }, React.createElement(Button, {
    icon: ICON_NAMES.MINUS,
    isOutlined: true,
    isRounded: true,
    onClick: handleDecrement
  }), React.createElement(Paragraph, null, renderValue(value)), React.createElement(Button, {
    icon: ICON_NAMES.PLUS,
    isOutlined: true,
    isRounded: true,
    onClick: handleIncrement
  })));
};
Component.displayName = 'Counter';
Component.defaultProps = {
  max: undefined,
  min: 0,
  name: '',
  onChange: Function.prototype,
  renderValue: function renderValue(value) {
    return value;
  },
  value: 0
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  renderValue: PropTypes.func,
  value: PropTypes.number
} : {};